module.exports = __webpack_public_path__ + "static/media/MyZoneErpHorizontalWhite.4cf1a06a.svg";